<template>
  <div class="animated fadeIn">
    <div id="Setting">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i>
          Settings
          <b-button
            @click="addSetting"
            size="sm"
            title="Add Setting"
            style="float: right;margin-bottom: 5px;"
          >
            <i class="fa fa-plus" aria-hidden="true"></i>
          </b-button>
        </div>
        <div class="card-body">
          <b-table :items="settings" :fields="fields">
            <template slot="commands" slot-scope="item">
              <b-button
                size="sm"
                variant="info"
                title="Edit Setting"
                class="active"
                @click="editSetting(item.item)"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { settingService } from "@/resources";
import { mapState, mapActions } from 'vuex';
export default {
  data() {
    return {
      //settings: [],
      fields: ['commands', 'key', 'value', 'description']
    };
  },
  computed: mapState({ settings: state => state.settings.all }),
  methods: {
    ...mapActions('settings', ['getAll']),
    editSetting(item) {
      this.$router.push({ name: 'EditSetting', params: { id: item.key } });
    },
    addSetting() {
      this.$router.push({ name: 'AddSetting' });
    }
  },
  created() {
    this.getAll();
    // if (!this.settings) {

    // }

    //console.log(this.settings);
    // let loader = this.$loading.show();
    // settingService.getAll().then(result => {
    //   this.settings = result.data;
    //   loader.hide();
    // });
  }
};
</script>

